import { z } from "zod";
import { EntityBase } from "./common.js";
import { Id } from "./ids.js";

/** Scoped settings, resolved unit → organization → global (architecture §8.1). */

/** `module.key`, registered in a module manifest. */
export const SettingKey = z.string().regex(/^[a-z][a-z0-9-]*\.[a-z][a-zA-Z0-9.-]*$/);

export const SettingScope = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("global") }),
  z.object({ kind: z.literal("organization"), id: Id }),
  z.object({ kind: z.literal("unit"), id: Id }),
]);
export type SettingScope = z.infer<typeof SettingScope>;

export const SettingValue = EntityBase.extend({
  key: SettingKey,
  scope: SettingScope,
  /** Validated against the key's own schema from the manifest. */
  value: z.json(),
});
export type SettingValue = z.infer<typeof SettingValue>;
